import { useMutation } from '@tanstack/react-query'
import { postAddCustomerWallet } from 'services/CustomerService'

export const useAddCustomerWalletRequest = () => {
  return useMutation({
    mutationFn: postAddCustomerWallet,
  })
}
